import * as React from 'react';
import { px } from 'csx';
import { style } from 'typestyle';
import { PageContainer } from '../PageContainer';
import { HeaderBannerMinimal } from './HeaderBannerMinimal';
import SimpleMasthead from '../molecules/mastheads/SimpleMasthead';
import { Container } from '../atoms/Container';
import { mediaDesktop } from '../utilities/mediaQueries';
import { centerCenter, vertical } from 'csstips';
import { spacing } from '../../../theme/spacing';
import { rebrand } from '../../../theme/color';
import { SUPPORT_HUB } from '../../../constants';
import { Link } from '../atoms/Link';
import { Button } from '../atoms/button/Button';
import { ButtonProminence, ButtonSize } from '../atoms/button/buttonStyles';

interface PageErrorProps {
  onReload?: () => void;
}

export const PageError: React.FC<PageErrorProps> = ({ onReload = null }) => (
  <>
    <SimpleMasthead className={styles.masthead}>
      <Container>
        <h1>Something went wrong</h1>
      </Container>
    </SimpleMasthead>
    <div data-test-app-error className={styles.content}>
      <Container>
        <p>
          If you keep seeing this message, please <Link href={SUPPORT_HUB}>submit a support ticket</Link>.
        </p>
        {onReload && typeof onReload === 'function' && (
          <p>
            <Button prominence={ButtonProminence.PRIMARY} size={ButtonSize.MEDIUM} onClick={onReload}>
              Try again
            </Button>
          </p>
        )}
      </Container>
    </div>
  </>
);

const styles = {
  masthead: style(
    vertical,
    centerCenter,
    {
      backgroundColor: rebrand.contrast[50].toHexString(),
      minHeight: px(172),
      $nest: {
        '& h1': {
          margin: 0,
        },
      },
    },
    mediaDesktop({
      padding: `${spacing.XXLARGE} 0`,
    })
  ),
  content: style(
    {
      padding: `${spacing.XLARGE} 0`,
      $nest: {
        '& p': {
          margin: `0 0 ${spacing.DEFAULT}`,
          $nest: {
            '&:last-child': {
              marginBottom: 0,
            },
          },
        },
        '& a': {
          textDecoration: 'underline',
        },
      },
    },
    mediaDesktop({
      padding: `${spacing.XXLARGE} 0`,
    })
  ),
};
